import bym from './bym/index'
export default {
    namespaced : true,
    modules : {
        bym
    }
}